module.exports = __webpack_public_path__ + "img/swiper_03.31fb0b63.jpg";